import { useState, useEffect } from "react";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/solid"; // Import Heroicons
import { getFAQs } from "./_request";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getFAQs()
      .then((res) => {
        if (res.success && res.data) {
          setFaqs(res.data);
        } else {
          setFaqs([]);
        }
        setLoading(false);
      })
      .catch(() => {
        setFaqs([]);
        setLoading(false);
      });
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-24">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
      </div>
    );
  }
  if (!faqs.length) {
    return (
      <div className="text-center text-gray-500 py-8">
        کوئی سوال دستیاب نہیں
      </div>
    );
  }

  return (
    <div className="max-w-2xl md:max-w-3xl mx-auto p-4 md:p-8" dir="rtl">
      <div className="space-y-4 mb-8">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={index} className="rounded-lg p-4 md:p-6 bg-[#F1FBFF]">
              <button
                className="flex flex-row-reverse justify-between items-center w-full"
                onClick={() => toggleFAQ(index)}
              >
                <span
                  className={`font-nastaleeqKasheeda text-lg md:text-xl lg:text-2xl text-right ml-auto transition-colors duration-200 ${
                    isOpen
                      ? "text-[#009EDE]"
                      : "text-black hover:text-[#009EDE]"
                  }`}
                >
                  {faq.question}
                </span>
                {isOpen ? (
                  <ChevronUpIcon className="w-6 h-6 md:w-7 md:h-7 text-[#009EDE]" />
                ) : (
                  <ChevronDownIcon className="w-6 h-6 md:w-7 md:h-7 text-[#009EDE]" />
                )}
              </button>
              {isOpen && (
                <p className="mt-2 text-xl md:text-2xl text-black text-right whitespace-pre-line font-nastaleeqRegular">
                  {faq.answer}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
